<template>
  <form @submit.prevent="roleAction">
    <div class="mb-3">
      <label>Name</label>
      <input
          v-model="role.name"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.role.name.$error,
          }"
      />
      <p
          v-for="error of v$.role.name.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Permissions</label>
      <multiselect v-model="role.permissions" :options="permissions.objects" :class="{
                        'is-invalid': v$.role.permissions.$error,
                  }" :multiple="true" :close-on-select="false" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name">
      </multiselect>
      <p
          v-for="error in v$.role.permissions.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Dashboard Settings</label>
      <multiselect v-model="role.widgets" :options="widgets" class="multiselect-height-3" placeholder="Select one" :multiple="true"></multiselect>
    </div>
    <div v-for="(error, index) in userSettingsErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-3 h3" disabled v-if="userSettingsLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Multiselect from "vue-multiselect";
import {ALL_PERMISSIONS} from "@/gql";
export default {
  name: "new-user-role-form",
  components: {Multiselect},
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      role: this.selected_role,
      permissions: {
        objects: []
      },
      widgets:[ 'User Activity', 'Sales Performance', 'Orders For Collection', 'Orders For Delivery', 'Payments Collected', 'Payments Due'],
    }
  },
  computed: {
    ... mapGetters({
      userSettingsLoading: 'user/userSettingsLoading',
      userSettingsErrors: 'user/userSettingsErrors'
    }),
  },
  props: {
    selected_role: {
      type: Object,
      default () {
        return {
          name: "",
          permissions: '',
          dashboard: "",
          widgets: "",
        }
      }
    },
    button_text: {type: String}
  },
  apollo: {
    permissions: {
      query: ALL_PERMISSIONS,
      variables () {
        return {
          page: 0,
          perPage: 30
        }
      }
    }
  },
  validations () {
    return {
      role: {
        name: {required},
        permissions: {required}
      }
    }
  },
  methods: {
    async roleAction() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      const new_role = []
      this.role.permissions.forEach(object => {
        new_role.push({id: object.id})
      })
      const data = {
        name: this.role.name,
        permissions: new_role,
        widgets: this.role.widgets
      }
      await this.$emit('roleAction', data)

      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
